import { render } from "./ApplicationForm.vue?vue&type=template&id=37e453d8"
import script from "./ApplicationForm.vue?vue&type=script&lang=js"
export * from "./ApplicationForm.vue?vue&type=script&lang=js"

import "./ApplicationForm.vue?vue&type=style&index=0&id=37e453d8&lang=css"

import exportComponent from "/Users/tin/Documents/asket/stone-xxi.ru-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__